// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".how-it-works-derek__avatar{width:109px}@media(min-width:0)and (max-width:767px){.how-it-works-derek__avatar{width:64px}}.how-it-works-derek .carousel-indicators{position:relative!important;margin-top:48px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
